export const initialState = {
  isMobileNavOpen: false,
  showWhereAreYouModal: false,
  banners: {
    blackFriday: false,
    shipBy: false,
    vacationMode: false,
    hyperwallet: false,
  },
  navbarHeight: 0,
};
